import { flowIdCyclingVlaanderenContractFlowId } from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';

const useStartCyclingVlaanderenContractFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { reset } = useFlowsResetState();

  return async (
    uuid?: string,
    inputUrl?: string,
    partyId?: string,
    quoteId?: string,
  ) => {
    reset();

    await initFlow({
      flowId: flowIdCyclingVlaanderenContractFlowId,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
      },
      inputUrl,
      outputUrl: `/sales-conversation/bikmo/finalize`,
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartCyclingVlaanderenContractFlow;
